<template>
    <h1>Email Analytics</h1>
</template>
<script>
export default {
    name: 'emailAnalytics'
}
</script>